import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { RULE_REC_TYPE } from '../../../constants';
import PolicyStore from '../../../stores/Policy/PolicyStore';
import ConcurrencyPopUp from '../../ConcurrencyPopUp/ConcurrencyPopUp';
import { FuseConsoleCardFooter } from '../../ConsoleFragments';
import { FTBody, Page, Card, FTHeading } from '../../Fuse';
import StackL from '../../Spacers/Spacers';
import { TStrong } from '../../Text/Text';
import CustomCategoriesModal from '../CustomCategories/CustomCategoriesModal';
import PolicyTable from '../PolicyTable';
import PriorityModal from '../PriorityModal';
import RedirectRulesModal from './RedirectRulesModal';
import { ROLE_READ_ONLY } from '../../../stores/Administrators/AdministratorModalStore';
import ConsoleStore from '../../../stores/ConsoleStore';

class RedirectRules extends Component {
    static propTypes = {
        console: ConsoleStore.PropType,
        policy: PolicyStore.PropType.isRequired,
    };

    renderTable = (priorityMode) =>
        <PolicyTable
            changePriorityAction
            itemName="Rule"
            itemNameFull="Redirect Rule"
            loadFailedMessage="Failed to load Redirect Rules."
            noItemsText="adding a Redirect Rule"
            priorityMode={priorityMode}
            readOnly={this.props.console.authority === ROLE_READ_ONLY.value}
            searchPlaceholder="Search by Name"
            store={this.props.policy.redirectRules.policyTable}
        />;

    render = () => {
        const { policyTable } = this.props.policy.redirectRules;

        return <Fragment>
            <Page title="Policies - Redirect Rules">
                {this.renderTable()}
                {this.renderAboutSection()}
            </Page>

            <RedirectRulesModal/>
            <CustomCategoriesModal />

            <PriorityModal
                store={policyTable}
                subTitle={' - Redirect Rules'}
                errMsg={'Failed to change rules priorities'}
            >
                {this.renderTable(true)}
            </PriorityModal>

            <ConcurrencyPopUp
                store={policyTable.concurrencyPopUpStore}
                revisionType={RULE_REC_TYPE.REDIRECT_RULES}
            />
        </Fragment>;
    }

    renderAboutSection = () => {
        return <Card title="What are Redirect Rules?">

            <FTBody>
                Redirect Rules send matching TAP URL Defense links to open Isolation (URL Isolation Only).
            </FTBody>
            <StackL />
            <FTHeading>When are Redirect Rules Applied?</FTHeading>
            <StackL />
            <FTBody>
                When a user clicks a rewritten TAP URL Defense link,
                the system applies a Policy based on the URL request’s detected attributes.
                If there are no matching Exclusion Rules, the system will check Redirect Rules.
            </FTBody>
            <StackL />
            <FTBody>
                The highest-matching Redirect Rule is applied, and the URL is sent to Isolation.
                If no Redirect Rules match, the URL opens in the user’s native browser.
            </FTBody>
            <StackL />
            <FTBody>
                After a redirected URL opens in Isolation, if there are no matching Exclusion Rules,
                the system enforces a Content Rule that either blocks the Isolated page content or allows
                it with defined page controls.
            </FTBody>
            <StackL />
            <FTHeading>How to Use Redirect Rules</FTHeading>
            <StackL />
            <FTBody><TStrong>
                Step 1. Add Redirect Rules for specific use cases
            </TStrong></FTBody>
            <StackL />
            <FTBody>Name the Rule and specify its match criteria.</FTBody>
            <StackL />
            <FTBody><TStrong>
                Step 2. Stack-rank Redirect Rules in the Console
            </TStrong></FTBody>
            <StackL />
            <FTBody>
                Rules are applied based on priority.
                Only the highest-ranking Rule with matching criteria is applied.
                This allows you to create Rules with specific exemptions that will override more broad Rules.
            </FTBody>
            <StackL />
            <FTHeading>Common Use Case</FTHeading>
            <StackL />
            <FTBody>
                To send high-risk URLs to Isolation so users can safely access high risk content without hampering
                productivity, create a Redirect Rule for specific PPS Cloud Sync User Groups such as VAPs.
            </FTBody>
            <StackL />
            <FuseConsoleCardFooter
                text={`For the best compatibility with TAP URL Defense,
                    a Redirect Rule will match its specified users with their TAP PPS Cloud Sync User Groups.`}
            />
        </Card>;
    }
}

export default inject('console', 'policy')(observer(RedirectRules));
